import * as types from '../constants/ActionTypes';
import * as contactTypes from '../../contactUs/constants/ActionTypes';

const initialState = {
  isLoading: false,
  defaultTopReason: [],
  isDisplayTopReason: false,
  isInputFocused: false,
  complaintsPageFaqs: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_TOP_CONTACT_REASONS:
      return { ...state, isLoading: true, defaultTopReason: [] };
    case types.DEFAULT_TOP_SEARCH_REASON:
      return { ...state, isLoading: false, defaultTopReason: action.payload };
    case types.DEFAULT_TOP_SEARCH_REASON_ERROR:
      return { ...state, isLoading: false, defaultTopReason: [] };
    case types.SHOW_TOP_CONTACT_REASON:
      return { ...state, isDisplayTopReason: true, isLoading: false };
    case types.SEARCHBAR_INPUTBOX_FOCUS: {
      const isInputFocused = action.payload;
      return {
        ...state, isInputFocused,
      };
    }
    case types.HIDE_TOP_CONTACT_REASON:
    case contactTypes.SPEECH_START_RECORDING:
    case contactTypes.SPEECH_RECOGNITION_REQUEST:
    case contactTypes.SPEECH_END_REQUEST:
      return { ...state, isDisplayTopReason: false, isLoading: false };
    case types.COMPLAINTS_PAGE_COMMON_QUESTIONS:
      return { ...state, isLoading: false, complaintsPageFaqs: action.payload };
    default:
      return state;
  }
}
